<template>
  <div class="account">
    <div class="account-cover"></div>
    <!-- <div class="container" v-if="res&&userInfo"> -->
    <div class="container">
      <!-- 申请状态栏 -->
      <user-status></user-status>
      <!-- 头像组件 -->
      <div class="dashbord">
        <div class="left">
          <left-nav @listData="lisData"></left-nav>
        </div>
        <div class="right">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import leftNav from './leftNav'
import userStatus from './userStatus'
import { mapState, mapMutations } from 'vuex'
// import service from '@/service'
export default {
  components: {
    leftNav,
    userStatus
  },
  data () {
    return {
      res: false, // 请求状态
      listId: 0
    }
  },
  computed: {
    ...mapState([ 'isLogin', 'userInfo', 'isBottom' ]),
    href () {
      return window.location.href
    }
  },

  created () {},
  mounted () {
    // 监听页面到底操作
    window.addEventListener('scroll', this.onScroll)
  },
  watch: {
    'isLogin': {
      handler: function (n) {
        if (n !== true) {
          window.location = `https://account.geekbang.org/infoq/login?redirect=${encodeURIComponent(this.href)}`
        }
        this.res = true
      }
    }
  },

  methods: {
    ...mapMutations({
      // 检测是否到底
      setBottom: 'CHECK_BOTTOM'
    }),
    lisData (data) {
      this.listId = data
      console.log('data', data)
    },
    // 页面到底操作
    onScroll () {
      const groupScroll = document.querySelector('.right')
      // // 滚动距离
      // const scrollTop = window.pageYOffset
      // 当前可视化区域的距离
      const windowHeight = Math.ceil(window.innerHeight)
      // 当前元素距离底部距离
      const groupHeight = groupScroll.getBoundingClientRect()
      this.setBottom(Number(windowHeight) >= Math.ceil(groupHeight.bottom))
    }
  },
  // 销毁监听
  destroyed () {
    // 销毁监听
    window.removeEventListener('scroll', this.onScroll)
  }
}
</script>
<style scoped lang='sass'>
@import '../../style/bulma/app.sass'

.account
  background-color: #f5f5f5
  padding-top: 30px
  .account-cover
    position: fixed
    top: 0
    bottom: 0
    left: 0
    right: 0
    z-index: -1
  .container
    .dashbord
      display: flex
      justify-content: space-between
      align-items: stretch
      padding: 30px 0
      .left
        width: 23%
        min-height: 700px
        border-radius: 5px
        background-color: #fff
      .right
        width: 74.3%
        border-radius: 5px
        background-color: #fff
</style>
